import Index from '@/views/applicationWindows/Index'
import Create from '@/views/applicationWindows/Create.vue'
import Show from '@/views/applicationWindows/Show.vue'
import TeamApplicationShow from '@/views/applicationWindows/teamApplications/Show.vue'

export default [
  {
    path: ':clientId/application-windows',
    name: 'applicationWindow.index',
    component: Index,
    meta: { featureKey: 'application-windows' }
  },
  {
    path: ':clientId/application-windows/create',
    name: 'applicationWindow.create',
    component: Create,
    meta: { featureKey: 'application-windows' }
  },
  {
    path: ':clientId/application-windows/:applicationWindow',
    name: 'applicationWindow.show',
    component: Show,
    meta: { featureKey: 'application-windows' }
  },
  {
    path: ':clientId/application-windows/:applicationWindow/team-applications/:teamApplication',
    name: 'teamApplication.show',
    component: TeamApplicationShow,
    meta: { featureKey: 'application-windows' }
  }
]
